<app-print-label-template-list></app-print-label-template-list>

<lib-button-input-portal [portalKey]="'displayableContentKey'">
  <lib-button-primary (buttonClicked)="viewModel.openCreatePrintLabelTemplateModal()">
    Create Label Template
  </lib-button-primary>
</lib-button-input-portal>
